import "./Spinner.scss";

const Spinner = ({ btnSpinner, color }) => (
  <div className={btnSpinner ? "btn-spinner-container" : "spinner-container"}>
    <div className={btnSpinner ? "btn-spinner" : "spinner " + color}></div>
  </div>
);

export default Spinner;
